import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { Modal as ModalWrapper } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';

import './OurAddress.sass';

interface IOurAddressProps {
  open: boolean;
  handleOpen?: () => void;
  handleClose: () => void;
  address?: string;
  children: any;
}

export const OurAddress: FC<IOurAddressProps> = ({
  open,
  handleClose,
  address,
  children,
}) => {
  return (
    <div className="our-address">
      <ModalWrapper keepMounted open={open} onClose={handleClose}>
        <Box className="our-address__wrapper">
          <Box className="our-address-top">
            <Box className="our-address-top__wrapper">
              <Box className="our-address-top__left">
                <PlaceOutlinedIcon
                  className="our-address__img"
                  color="disabled"
                />
                <h2 className="our-address-top__title">
                  {address ? address : 'ул. Дальзаводская 4, пав. №101'}
                </h2>
              </Box>
              <Box className="our-address-top__right" onClick={handleClose}>
                <CloseRoundedIcon
                  className="our-address__img close"
                  color="disabled"
                />
              </Box>
            </Box>
          </Box>
          <div className="our-address-bottom">{children}</div>
        </Box>
      </ModalWrapper>
    </div>
  );
};
